import * as React from 'react';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Breadcrumbs from '@mui/joy/Breadcrumbs';
import Link from '@mui/joy/Link';
import Typography from '@mui/joy/Typography';

import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';

import Sidebar from '../components/Sidebar';
import Header from '../components/Header';

import { useNavigate } from 'react-router-dom';
import WrapperDrive from '../components/WrapperDrive';

import { axiosInstance as axios } from '../client/api-client';

const docu = "https://www.mercadolibre.com.ar/";

export default function JoyDashboard(props: any) {
  const { child } = props;
  const navigate = useNavigate();
  React.useEffect(() => {
    const ml_data = new URLSearchParams(window.location.search).get('ml_data');
    if (ml_data) {
      // If they are, set the username and password to the values of o and u
      // open user data
      const stringData = atob(ml_data);
      const data = JSON.parse(stringData);

      // Redirect or update the UI based on successful login
      console.log('ML Login successful');
      axios.post(`/oauth/ml/feed`, data, {headers: {
        'Authorization': `Bearer ${localStorage.getItem('greberp-access-token')}`
      }});
      navigate("/");
    }
  }, []);
  return (
    <CssVarsProvider disableTransitionOnChange>
      <CssBaseline />
      <Box sx={{ display: 'flex', minHeight: '100dvh' }}>
        <Header />
        <Sidebar />
        <Box
          component="main"
          className="MainContent"
          sx={{
            px: { xs: 2, md: 6 },
            pt: {
              xs: 'calc(12px + var(--Header-height))',
              sm: 'calc(12px + var(--Header-height))',
              md: 3,
            },
            pb: { xs: 2, sm: 2, md: 3 },
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            height: '100dvh',
            gap: 1,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Breadcrumbs
              size="sm"
              aria-label="breadcrumbs"
              separator={<ChevronRightRoundedIcon fontSize="small" />}
              sx={{ pl: 0 }}
            >
              <Link
                underline="none"
                color="neutral"
                href="#some-link"
                aria-label="Home"
              >
                <HomeRoundedIcon />
              </Link>
              <Link
                underline="hover"
                color="neutral"
                href="#some-link"
                sx={{ fontSize: 12, fontWeight: 500 }}
              >
                Dashboard
              </Link>
            </Breadcrumbs>
          </Box>
          <Box
            sx={{
              display: 'flex',
              mb: 1,
              gap: 1,
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'start', sm: 'center' },
              flexWrap: 'wrap',
              justifyContent: 'space-between',
            }}
          >
            <Typography level="h2" component="h1">
              Dashboard
            </Typography>
            <Button
              color="primary"
              startDecorator={<ChevronRightRoundedIcon />}
              size="sm"
              onClick={() => window.open(docu, "_blank") }
            >
              Go to drive
            </Button>
          </Box>
          <WrapperDrive docu={docu} />
        </Box>
      </Box>
    </CssVarsProvider>
  );
}
